import type { ReactElement, ReactNode } from 'react';

type ColumnCornerProps = {
  readonly edge: 'top' | 'bottom';
  readonly children: ReactNode;
};

/**
 * A control that floats over the page, hung off the content column rather than
 * the window: pinned to the viewport edge it drifts out over empty canvas on a
 * wide screen, and lands under the browser's own furniture on a narrow one.
 * The positioner spans the width but takes no pointer events, so only the
 * control itself is clickable.
 */
export const ColumnCorner = ({ edge, children }: ColumnCornerProps): ReactElement => (
  <div
    className={`pointer-events-none fixed inset-x-0 z-30 ${edge === 'top' ? 'top-4' : 'bottom-4'}`}
  >
    <div className="mx-auto flex max-w-wide justify-end px-6">
      <div className="pointer-events-auto flex min-w-0">{children}</div>
    </div>
  </div>
);
